import { CancelablePromise } from '../types';

const requests: Record<string, CancelablePromise<any>> = {};

export const runCancelableQuery = async <T>(requestKey: string, cb: () => CancelablePromise<T>): Promise<T | undefined> => {
  try {
    if (requests[requestKey] !== undefined) {
      requests[requestKey].cancel()
    }

    const requestPromise = cb();
    requests[requestKey] = requestPromise;

    const result = await requestPromise;
    delete requests[requestKey];

    return result;
  } catch (e: any) {
    if (e.name !== 'CancelError') {
      delete requests[requestKey];
      throw e;
    }
  }
}
